import React from "react";
import ArrowBackLight from "@assets/navigation/back.svg";
import { useNavigate } from "react-router-dom";
import { useMediaQuery } from "react-responsive";

interface AppBarProps {
  title: string;
  path?: string;
  onClick?: () => void;
  onClickQr?: () => void;
  endComponent?: React.ReactNode;
  componentAfterTitle?: React.ReactNode;
  backNavigationState?: object;
  qr?: boolean;
  myReferrals?: boolean;
  showReward?: boolean;
  showBackNavigation?: boolean;
}

const AppBarMobile: React.FC<AppBarProps> = ({
  title,
  path,
  onClick: handleLogout,
  endComponent,
  componentAfterTitle,
  backNavigationState,
  qr = false,
  showBackNavigation = true,
}) => {
  const navigate = useNavigate();
  const isMobile = useMediaQuery({ query: "(max-width: 640px)" });

  const handleBack = () => {
    if (path !== undefined) {
      // Explicitly check if 'path' is provided
      console.log("path click inside");
      if (path.length > 0) {
        navigate(`/${path}`, { state: backNavigationState });
      } else {
        navigate("/", { state: backNavigationState });
      }
    } else {
      console.log("path click outside", path);
      navigate(-1);
    }
  };

  return (
    <div
      className={`${
        isMobile
          ? "fixed top-0 w-full z-50 bg-bg-base"
          : "h-[70px] border-b border-b-border-subtle bg-bg-page-body"
      }`}
    >
      <div
        className={`${
          isMobile
            ? "flex flex-row justify-between items-center py-[16px] px-[20px] cursor-pointer"
            : "flex flex-row justify-between items-center h-[70px] px-[20px] cursor-pointer"
        }`}
      >
        <div className="flex flex-row items-center space-x-[16px] cursor-pointer">
          {showBackNavigation && (
            <img
              src={ArrowBackLight}
              alt="Back"
              className="cursor-pointer"
              onClick={handleBack}
            />
          )}
          <div className="flex flex-row space-x-[8px]">
            <div className="text-text-base text-[16px] font-medium whitespace-nowrap overflow-hidden text-ellipsis">
              {title}
            </div>
            {componentAfterTitle && <div>{componentAfterTitle}</div>}
          </div>
        </div>{" "}
        {endComponent && <div>{endComponent}</div>}
      </div>
    </div>
  );
};

export default AppBarMobile;
